import React from 'react';

import HistoryCard from './card';

import './styles.scss';

export default function ActivitiesTab() {
  return (
    <div className="deal-history-tab">
      <HistoryCard />
    </div>
  );
}
